import { useState } from 'react'
import { EMPTY_HISTORY_PNG } from 'consts/images'
import { Text } from 'common-components'
import AiSkeletonItem from 'components/AISkeletonItem'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import * as Styled from './styled'

export const AiIconTabEmptyHistory = () => {
  const [isImageLoading, setIsImageLoading] = useState(true)

  return (
    <Styled.AiIconTabEmptyHistoryContainer>
      <Styled.EmptyImageWrapper>
        {isImageLoading && <AiSkeletonItem />}
        <Styled.EmptyHistoryImg
          src={EMPTY_HISTORY_PNG}
          alt="Empty history"
          onLoad={() => setIsImageLoading(false)}
          $isImageLoading={isImageLoading}
        />
      </Styled.EmptyImageWrapper>
      <Text type="h1" color="secondarySemiDark">
        {translate(T.HISTORY_EMPTY_TITLE)}
      </Text>
      <Text type="h2" color="secondary">
        {translate(T.HISTORY_EMPTY_DESCRIPTION)}
      </Text>
    </Styled.AiIconTabEmptyHistoryContainer>
  )
}
